<template>
    <div>
        <CFTitle title="28. Buget - Tip de finanțare"></CFTitle>
        <div class="tip-finantare">
            <table>
                <thead>
                    <tr>
                        <th class="table-head blue-head" style="width: 33.3%"><p>Tip finantare</p></th>
                        <th class="table-head blue-head" style="width: 33.3%"><p>Buget</p></th>
                        <th class="table-head blue-head" style="width: 33.3%"><p>% din totalul bugetului</p></th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td style="width: 33.3%;" class="first-in-row">01. Grant nerambursabil</td>
                        <td style="width: 33.3%">{{ bugetData && bugetData.nerambursabil ? bugetData.nerambursabil.RON : 0 }} LEI</td>
                        <td style="width: 33.3%">{{ bugetData && bugetData.nerambursabil ? bugetData.nerambursabil.procent : 0 }}%</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import CFTitle from "./CFTitle";

    export default {
        components: {
            CFTitle
        },
        props: {
            bugetData: null
        },
        data() {
            return {

            }
        },
        mounted() {
            this.$store.dispatch('finantare/addToProgress', 'Buget - Tip de finanțare')
        },
        methods: {
        }
    }
</script>
<style scoped>
.tip-finantare{
  margin-top: 40px;
}
table, th, td {
  border: 1px solid #979696;
  width: 100%;
  height: 100%;
  text-align: center;
}
td{
  font-size: 14px;
  padding: 5px;
}
.padding-td tr td:first-child{
  padding: 10px;
}
.table-head p{
  font-size: 14px;
  text-align: center;
  font-weight: 700;
  text-transform: uppercase;
}
.table-head{
  padding: 10px;
  border: 1px solid #979696;
  border-bottom: 0;
  position: relative;
}
.blue-head{
  background: #bdd6ee;
}
</style>